import React from 'react';
import { render } from 'react-dom';
import { __ } from '@wordpress/i18n';

import { CalculatorChoco } from '../../calculators/components/Calculator/CalculatorChoco';

// if this title is not set separately, it is somehow not seen by wp-cli
const fixTitleBig = __('Chocolate Toxicity Calculator', 'cooperpetcare');

const allStrings = [
  __('White', 'cooperpetcare'),
  __('Milk', 'cooperpetcare'),
  __('Semi-sweet', 'cooperpetcare'),
  __('60% cocoa dark', 'cooperpetcare'),
  __('85% cocoa dark', 'cooperpetcare'),
  __('Unsweetened', 'cooperpetcare'),
  __('Dry cocoa powder', 'cooperpetcare'),
  __('Likely none', 'cooperpetcare'),
  __('Possibly mild gastrointestinal upset', 'cooperpetcare'),
  __('Mild', 'cooperpetcare'),
  __('May show signs of Vomiting, Diarrhea, Shaking, Elevated Heart Rate, Increased Urination', 'cooperpetcare'),
  __('Moderate to severe', 'cooperpetcare'),
  __('Tremors, seizures, heartbeat may be irregular or rapid, potential for collapse', 'cooperpetcare'),
  __('Potentially fatal', 'cooperpetcare'),
  __('Hot to the touch, collapse, irregular heart beat, breathing problems, racing heart, potential sudden death', 'cooperpetcare'),
  __('Chocolate type:', 'cooperpetcare'),
  __('Please select an option', 'cooperpetcare'),
  __('Weight of chocolate in grams:', 'cooperpetcare'),
  __('Weight of chocolate in grams', 'cooperpetcare'),
  __('Weight of the pet (kg):', 'cooperpetcare'),
  __('Weight of your pet in kilograms', 'cooperpetcare'),
  __('Calculate', 'cooperpetcare'),
];

const blockWrapperClass = 'block-container__' + 'calc-choco';
const wrappers = document.getElementsByClassName(blockWrapperClass);

for (let wrapper of wrappers) {
  render(<CalculatorChoco />, wrapper);
}
